import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MultiUserFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M13.5647 15.2193C14.1348 15.5276 15.0292 16.0112 15.6409 16.5857C16.0219 16.9435 16.4159 17.4428 16.4883 18.0778C16.5665 18.7649 16.2485 19.3852 15.6772 19.9074C14.7182 20.784 13.5522 21.4996 12.0399 21.4996H4.96015C3.44779 21.4996 2.28177 20.784 1.3228 19.9074C0.751481 19.3852 0.433458 18.7649 0.511739 18.0778C0.584083 17.4428 0.978131 16.9435 1.35906 16.5857C1.97085 16.0112 2.86511 15.5276 3.43523 15.2193C3.56216 15.1507 3.67304 15.0907 3.76114 15.0404C6.66339 13.3824 10.3366 13.3824 13.2389 15.0404C13.3269 15.0907 13.4378 15.1507 13.5647 15.2193Z"
				fill="currentColor"
			/>
			<path
				d="M3.59375 7.37838C3.59375 4.68412 5.78894 2.5 8.49684 2.5C11.2048 2.5 13.4 4.68412 13.4 7.37838C13.4 10.0726 11.2048 12.2568 8.49684 12.2568C5.78894 12.2568 3.59375 10.0726 3.59375 7.37838Z"
				fill="currentColor"
			/>
			<path
				d="M13.7776 10.9656C13.572 11.2407 13.4692 11.3783 13.5081 11.5144C13.5471 11.6506 13.6841 11.7128 13.9581 11.8373C14.5282 12.0963 15.1712 12.2419 15.8515 12.2419C18.1982 12.2419 20.1005 10.5088 20.1005 8.37097C20.1005 6.23309 18.1982 4.5 15.8515 4.5C15.5956 4.5 15.345 4.52061 15.1016 4.56011C14.8001 4.60902 14.6494 4.63347 14.5698 4.75422C14.4902 4.87497 14.5465 5.03357 14.6592 5.35075C14.8816 5.97695 15.0017 6.64504 15.0017 7.33871C15.0017 8.68342 14.5502 9.93204 13.7776 10.9656Z"
				fill="currentColor"
			/>
			<path
				d="M18.8881 20.5C20.42 20.5 21.6115 19.9038 22.6023 19.1596C23.1895 18.7186 23.5742 18.1506 23.4813 17.4806C23.3978 16.8788 22.9514 16.4309 22.5662 16.1336C21.9351 15.6466 21.0144 15.2377 20.4343 14.98C20.3062 14.9231 20.1947 14.8735 20.1065 14.8322C18.9761 14.3015 17.7324 13.9735 16.462 13.8483C15.6427 13.7676 15.2331 13.7272 15.1394 13.9501C15.0458 14.173 15.4106 14.4118 16.1402 14.8893C16.4172 15.0707 16.6853 15.265 16.9205 15.4673C17.45 15.9226 18.2264 16.7422 18.3728 17.9186C18.4407 18.4638 18.3621 18.9661 18.1854 19.4199C17.975 19.9603 17.8698 20.2305 17.9608 20.3586C17.9666 20.3668 17.9702 20.3713 17.9767 20.3791C18.0788 20.5 18.3485 20.5 18.8881 20.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MultiUserFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MultiUserFilledIcon;
